import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const MORE_LINKS = [
    { to: '/about', label: 'About Us' },
    { to: '/facility', label: 'Our Facility' },
    { to: '/quality', label: 'Quality' },
]

const ABOUT_PATHS = ['/about', '/story', '/facility', '/certifications', '/quality']
const isAboutPath = (path) => ABOUT_PATHS.some(p => path === p || path.startsWith(p + '/'))
const CLOSE_DELAY_MS = 150

const NavAboutDropdown = () => {
    const [open, setOpen] = useState(false)
    const wrapRef = useRef(null)
    const closeTimerRef = useRef(null)
    const location = useLocation()
    const inAboutSection = isAboutPath(location.pathname)

    const clearCloseTimer = () => {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current)
            closeTimerRef.current = null
        }
    }

    const openMenu = () => {
        clearCloseTimer()
        setOpen(true)
    }

    const scheduleClose = () => {
        clearCloseTimer()
        closeTimerRef.current = setTimeout(() => setOpen(false), CLOSE_DELAY_MS)
    }

    useEffect(() => {
        const handler = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [])

    useEffect(() => {
        setOpen(false)
    }, [location.pathname])

    useEffect(() => () => clearCloseTimer(), [])

    const close = () => setOpen(false)

    return (
        <div
            className={`v2-nav-dropdown v2-nav-dropdown--split${open ? ' is-open' : ''}${inAboutSection ? ' is-active' : ''}`}
            ref={wrapRef}
            onMouseEnter={openMenu}
            onMouseLeave={scheduleClose}
            onFocus={openMenu}
            onBlur={(e) => {
                if (!wrapRef.current?.contains(e.relatedTarget)) {
                    scheduleClose()
                }
            }}
        >
            <Link to="/about" className="v2-nav-dropdown-main">
                About
            </Link>
            <button
                type="button"
                className="v2-nav-dropdown-caret"
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
                aria-haspopup="true"
                aria-label="More about PFC"
            >
                <svg className="v2-nav-dropdown-chevron" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                    <path d="M2 3.5L5 6.5L8 3.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

            <div
                className={`v2-nav-dropdown-menu${open ? ' is-visible' : ''}`}
                role="menu"
                aria-hidden={!open}
            >
                <div className="v2-nav-dropdown-menu-panel">
                    {MORE_LINKS.map(({ to, label, children }) => (
                        <React.Fragment key={to}>
                            <Link to={to} role="menuitem" onClick={close} tabIndex={open ? 0 : -1}>
                                {label}
                            </Link>
                            {children && children.map(child => (
                                <Link key={child.to} to={child.to} role="menuitem" onClick={close} tabIndex={open ? 0 : -1} className="v2-nav-dropdown-sub">
                                    {child.label}
                                </Link>
                            ))}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default NavAboutDropdown
